import React from 'react';
import { useState, useRef, useEffect } from 'react';

const EnterCode = ({ handler }) => {
    const [code, setCode] = useState("")
    const inputElement = useRef(null);

    useEffect(() => {
        if (inputElement.current) {
            inputElement.current.focus();
        }
    }, []);
    const submit = () => {
        if (code.length !== 5) {
            alert("Der Code muss 5 Zeichen lang sein")

        } else {

            handler(code.toUpperCase())
        }
    }


    const divc = "p-2 text-center fs-1 fw-bold"

    return (
        <div className='container p-4 m-auto'>
            <h3>Code eingeben</h3>
            <p className='d-block w-100 text-end'>الرجاء إدخال الرمز</p>
            <div className="input-group input-group-lg">
                <span className="input-group-text" id="inputGroup-sizing-lg">Code:</span>
                <input
                    value={code}
                    maxLength={5}
                    ref={inputElement}
                    onChange={e => { setCode(e.target.value.toUpperCase()) }}
                    type="text" className="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-lg" />
            </div>
            <div className='d-flex flex-row' style={{ justifyContent: "space-around" }}>
                <div style={{ width: "25%" }}></div>
                <div className={divc}>{code[0] ? code[0].toUpperCase() : <span style={{ color: "#cccccc" }}>?</span>}</div>
                <div className={divc}>{code[1] ? code[1].toUpperCase() : <span style={{ color: "#cccccc" }}>?</span>}</div>
                <div className={divc}>{code[2] ? code[2].toUpperCase() : <span style={{ color: "#cccccc" }}>?</span>}</div>
                <div className={divc}>{code[3] ? code[3].toUpperCase() : <span style={{ color: "#cccccc" }}>?</span>}</div>
                <div className={divc}>{code[4] ? code[4].toUpperCase() : <span style={{ color: "#cccccc" }}>?</span>}</div>
                <div style={{ width: "25%" }}></div>
            </div>
            <button disabled={code.length === 0} className='mt-2 btn d-block w-100 btn-lg btn-primary' onClick={submit}>OK</button>
            <div className='text-center w-100 mt-3'>
                <p>
                    Der Code befindet sich auf der Karte, die Sie bekommen haben.
                </p>

                <p style={{ direction: "rtl" }}>
                    تجيدون الرمز على البطاقة التي وزعت.
                </p>
                <p>
                    You find the Code on the card you received.
                </p>
            </div>
        </div >
    );
};

export default EnterCode;